import api from './api';

// جلب جميع الإعدادات
export const getSettings = async () => {
  const response = await api.get('/settings');
  return response.data;
};

// جلب الإعدادات العامة
export const getPublicSettings = async () => {
  const response = await api.get('/settings/public');
  return response.data;
};

// جلب إعداد معين
export const getSettingByKey = async (key) => {
  const response = await api.get(`/settings/${key}`);
  return response.data;
};

// تحديث أو إنشاء إعداد
export const updateSetting = async (key, data) => {
  const response = await api.put(`/settings/${key}`, data);
  return response.data;
};

// حذف إعداد
export const deleteSetting = async (key) => {
  const response = await api.delete(`/settings/${key}`);
  return response.data;
};
